Array.prototype.nineBinarySearch = function(target)
{
	this.sort((a,b) => { return a > b ? 1 : -1; });
	
	let start = 0;
	let end = this.length-1
	let mid
	
	while (start <= end) { //점점 좁혀지다가 start와 end의 순서가 어긋나게 되면 반복을 종료한다
	
		mid = parseInt((start+end)/2)
		
		if (target == this[mid]) {
			return mid;
		}
		else{
			if (target < this[mid]){
				end = mid - 1;
			}
			else {
				start = mid + 1;
			}
		}
	}
	
	return -1;
};



